import React from 'react';

import { BasicProps } from '../../../types';
import * as styles from './ResultsCount.module.scss';

export interface Props extends BasicProps {
  count: number;
  searchString: string;
}

const ResultsCount: React.FC<Props> = ({ count, searchString }) => {
  return (
    <div className={styles.resultsCountContainer} data-testid="resultsCount">
      <div className={`darkContainer ${styles.resultCount} flexCenter`}>
        <p className="heading3">{count}</p>
      </div>
      <div>
        <p className={`${styles.resultsFor} heading6`}>Results for</p>
        <p className="heading5">"{searchString}"</p>
      </div>
    </div>
  );
};

export default ResultsCount;
